(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boom-sticky-buy"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('boom-sticky-buy')) {
  customElements.define('boom-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-boom-buy]');
      this.main = document.querySelector('product-info[id^="MainProduct-"]');
      if (!this.main) return;
      this.onClick = (event) => {
        const button = this.main.querySelector('product-form button[name="add"]');
        const qty = this.main.querySelector('input[name="quantity"]');
        if (!button) return;
        event.preventDefault();
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        if (qty && !qty.reportValidity()) {qty.scrollIntoView({block:'center'});qty.focus();return;}
        button.click();
        this.sync();
      };
      this.sync = () => {
        const button = this.main.querySelector('product-form button[name="add"]');
        const qty = this.main.querySelector('input[name="quantity"]');
        if (!button) return;
        const busy = button.classList.contains('loading');
        const disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
        this.link.setAttribute('aria-disabled', String(disabled));
        this.link.setAttribute('aria-busy', String(busy));
        this.link.textContent = busy ? 'Adding…' : (button.disabled ? button.innerText.trim() : 'Add to cart');
        this.querySelector('[data-boom-quantity]').textContent = '· Qty ' + (qty?.value || '1');
        const mainError = this.main.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
        const error = this.querySelector('[data-boom-error]');
        error.textContent = mainError?.textContent.trim() || '';
        error.hidden = !error.textContent;
      };
      this.link.addEventListener('click', this.onClick);
      this.main.addEventListener('input', this.sync);
      this.main.addEventListener('change', this.sync);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.main,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','aria-disabled','hidden','class']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.link?.removeEventListener('click',this.onClick);
      this.main?.removeEventListener('input',this.sync);
      this.main?.removeEventListener('change',this.sync);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
if(!customElements.get('boom-flavour-filter'))customElements.define('boom-flavour-filter',class extends HTMLElement{
connectedCallback(){this.hidden=false;this.onClick=(e)=>{const b=e.target.closest('button[data-flavour]');if(!b)return;this.filter(b.dataset.flavour)};this.addEventListener('click',this.onClick);this.filter('all')}
filter(group){const cards=Array.from(this.parentElement.querySelectorAll('#product-grid>li[data-boom-flavour]'));let count=0;cards.forEach(c=>{c.hidden=group!=='all'&&c.dataset.boomFlavour!==group;if(!c.hidden)count++});this.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.flavour===group)));this.querySelector('[data-flavour-count]').textContent=count+' of '+cards.length+' matching flavours shown.'}
disconnectedCallback(){this.removeEventListener('click',this.onClick)}
});

  } catch(e) { console.error(e); }
})();
})();
